import { Group, Pagination as MantinePagination, Select, Text } from '@mantine/core';

interface PaginationProps {
  total: number;
  page: number;
  onPageChange: (page: number) => void;
  limit: number;
  onLimitChange: (limit: number) => void;
}

export function Pagination({
  total,
  page,
  onPageChange,
  limit,
  onLimitChange,
}: PaginationProps) {
  const totalPages = Math.ceil(total / limit);

  return (
    <Group position="apart" mt="xl">
      <Group spacing="xs">
        <Text size="sm" color="dimmed">
          Items per page:
        </Text>
        <Select
          value={limit.toString()}
          onChange={(value) => onLimitChange(Number(value))}
          data={['10', '25', '50', '100']}
          style={{ width: 80 }}
        />
      </Group>
      <Group spacing="xs">
        <Text size="sm" color="dimmed">
          Showing {Math.min((page - 1) * limit + 1, total)} -{' '}
          {Math.min(page * limit, total)} of {total} items
        </Text>
        <MantinePagination
          total={totalPages}
          value={page}
          onChange={onPageChange}
          size="sm"
        />
      </Group>
    </Group>
  );
}

